import {Card, Table} from "react-bootstrap";
import PcValsDocumentsRead from "../PcValsDocumentsRead";
import React from "react";

type YearReportIndicatorProps = {
    indicators: {
        fixedPcs: Indicator[],
        pcs?: Indicator[]
    },
    filterYears: number[]
}

export default function YearReportIndicators({indicators, filterYears}: YearReportIndicatorProps){
    return (
        <Card className="mb-4">
            <Card.Header className="p-4">Показатели проекта</Card.Header>
            <Card.Body className="p-4">
                <div style={{ overflowX: 'scroll' }}>
                    {Object.entries(indicators).map(([indicatorType, indicatorsArray]) => indicatorsArray.length > 0 && <>
                        {Object.keys(indicators).length > 1 && <h2 className='mb-0' style={{fontSize: 18, color: '#EA7306', textAlign: 'left'}}>
                            {indicatorType === 'fixedPcs' ?
                                'Унифицированные показатели' :
                                'Неунифицированные показатели'}
                        </h2>}
                        <Table striped className="read-view">
                            <thead>
                            <tr>
                                <th>Наименование показателя</th>
                                <th>Единицы измерения</th>
                                {filterYears.map((e) => (
                                    <>
                                        <th>
                                            <div>План</div>
                                            {' '}
                                            <div>
                                                (
                                                {e}
                                                )
                                            </div>
                                        </th>
                                        <th>
                                            <div>Факт</div>
                                            {' '}
                                            <div>
                                                (
                                                {e}
                                                )
                                            </div>
                                        </th>
                                    </>
                                ))}
                                <th>Ключевой</th>
                                <th>Документы</th>
                            </tr>
                            </thead>
                            <tbody>
                            {indicatorsArray.map((p) => (
                                <tr key={p.id}>
                                    <td>{p.name}</td>
                                    <td>{p.unit}</td>
                                    {filterYears.map((year) => (
                                        <>
                                            <td>
                                                {
                                                    p.values[0]?.plan
                                                }
                                            </td>
                                            <td>
                                                {
                                                    p.values[0]?.fact ?
                                                        typeof p.values[0].fact === 'string' ?
                                                            isNaN(+p.values[0].fact) ?
                                                                p.values[0].fact :
                                                                p.values[0].fact.replace('.', ',') :
                                                            new Intl.NumberFormat('ru', {maximumFractionDigits: 2}).format(p.values[0].fact)
                                                        : '-'
                                                }
                                            </td>
                                        </>
                                    ))}
                                    <td>{p.isKey ? 'Да' : 'Нет'}</td>
                                    <td>
                                        <PcValsDocumentsRead data={p} />
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </>)}
                </div>
            </Card.Body>
        </Card>
    )
}
